// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

export class AssetHash {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): AssetHash {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  bits0(): bigint {
    return this.bb!.readUint64(this.bb_pos)
  }

  bits1(): bigint {
    return this.bb!.readUint64(this.bb_pos + 8)
  }

  bits2(): bigint {
    return this.bb!.readUint64(this.bb_pos + 16)
  }

  bits3(): bigint {
    return this.bb!.readUint64(this.bb_pos + 24)
  }

  bits4(): bigint {
    return this.bb!.readUint64(this.bb_pos + 32)
  }

  bits5(): bigint {
    return this.bb!.readUint64(this.bb_pos + 40)
  }

  bits6(): bigint {
    return this.bb!.readUint64(this.bb_pos + 48)
  }

  bits7(): bigint {
    return this.bb!.readUint64(this.bb_pos + 56)
  }

  static sizeOf(): number {
    return 64
  }

  static createAssetHash(
    builder: flatbuffers.Builder,
    bits_0: bigint,
    bits_1: bigint,
    bits_2: bigint,
    bits_3: bigint,
    bits_4: bigint,
    bits_5: bigint,
    bits_6: bigint,
    bits_7: bigint
  ): flatbuffers.Offset {
    builder.prep(8, 64)
    builder.writeInt64(BigInt(bits_7 ?? 0))
    builder.writeInt64(BigInt(bits_6 ?? 0))
    builder.writeInt64(BigInt(bits_5 ?? 0))
    builder.writeInt64(BigInt(bits_4 ?? 0))
    builder.writeInt64(BigInt(bits_3 ?? 0))
    builder.writeInt64(BigInt(bits_2 ?? 0))
    builder.writeInt64(BigInt(bits_1 ?? 0))
    builder.writeInt64(BigInt(bits_0 ?? 0))
    return builder.offset()
  }
}
